/**
 * @author jakubmaslon
 * @since 2020-07-03
 */

import * as React from "react";
import styled from "styled-components";

import { Paragraph } from "@ui/Atoms";
import { Star } from "@ui/Assets/Symbolicons/Star";
import theme from "@ui/themes/default";
import { rem } from "@ui/helpers";

interface Props {
  quote: string;
  author: string;
  rating: number;
}

const Testimonial = (props: Props): React.ReactElement => {
  const renderStars = (rating: number) => {
    const stars = [];

    for (let i = 0; i < rating; i++) {
      stars.push(
        <StarWrapper key={`star-${i}`}>
          <Star size={16} color={theme.palette.blue400} />
        </StarWrapper>,
      );
    }

    return stars;
  };

  return (
    <TestimonialStyled>
      <Quote>{props.quote}</Quote>
      <Author>{props.author}</Author>
      <div>{renderStars(props.rating)}</div>
    </TestimonialStyled>
  );
};
Testimonial.displayName = "Testimonial";

export { Testimonial };

const TestimonialStyled = styled.div`
  display: inline-block;
  min-width: ${rem(240)};
  max-width: ${rem(240)};
  padding: ${theme.margins.base_x4} ${theme.margins.base_x2}
    ${theme.margins.base_x8};
  background: ${theme.palette.white};

  ${theme.breakpoints.desktop} {
    min-width: ${rem(270)};
    max-width: ${rem(270)};
  }
`;

const Quote = styled(Paragraph)`
  min-height: ${rem(200)};
  font-style: italic;
`;

const Author = styled.div`
  margin-bottom: ${theme.margins.base_x2};
  color: ${theme.palette.grey600};
`;

const StarWrapper = styled.div`
  display: inline;
  margin-right: ${theme.margins.base};

  &:last-child {
    margin-right: 0;
  }
`;
